import { clsx } from 'clsx';
import { type ComponentPropsWithoutRef, type ReactNode } from 'react';

import { Flex } from '@repo/ui/Flex';
import { IconButton } from '@repo/ui/IconButton';
import { PopoverClose } from '@repo/ui/Popover/PopoverClose';

import s from './PopoverContentSimple.module.css';

export type PopoverContentSimpleProps = ComponentPropsWithoutRef<'div'> & {
  children?: ReactNode;
  className?: string;
  closeButtonLabel?: string;
  hasCloseButton?: boolean;
};

export const PopoverContentSimple = ({
  children,
  className,
  closeButtonLabel = 'Close',
  hasCloseButton = true,
  ...attrs
}: PopoverContentSimpleProps) => {
  return (
    <Flex
      direction={hasCloseButton ? 'row-reverse' : 'row'}
      className={clsx(s.simplePopover, className)}
      {...attrs}
    >
      {hasCloseButton && (
        <PopoverClose asChild={true}>
          <IconButton
            icon="close"
            label={closeButtonLabel}
            variant="tertiary"
          />
        </PopoverClose>
      )}
      <div className={s.content}>{children}</div>
    </Flex>
  );
};
